import React from 'react';

export const Page: React.StatelessComponent = (props) => {
    return (
        <main className="full-width" id="test">
            {props.children}
        </main>
    );
};